// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebaseConfig: {
    apiKey: "AIzaSyBHB7pLLcOKgGzxSXSW8yUDoXWM356D2zc",
    authDomain: "idiving-littlehelper.firebaseapp.com",
    databaseURL: "https://idiving-littlehelper-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "idiving-littlehelper",
    storageBucket: "idiving-littlehelper.appspot.com",
    messagingSenderId: "605010773203",
    appId: "1:605010773203:web:60757225158fc77c12c026",
    measurementId: "G-FHBSDFQV62"
  },
  GA_TRACKING_ID: 'UA-46520389-1'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
